<template>
  <b-tab>
    <template v-slot:title>Roles</template>
    <div>

      <!-- Major Permissions -->
      <div class="row">
        <div class="col-6">
          <h4 class="text-black">View System Roles</h4>
          <div class="text-danger mb-3"><i><b>"View Settings"</b> Permission has to be enabled!</i></div>
          <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="index">
            <div class="col-4">{{ item.rolename }}</div>
            <div class="col">
              <RockerSwitch v-if="item.view_system_roles == 1" :value="true"
                @change="changePermission(role = item.role, permission = 'view_system_roles')" />
              <RockerSwitch v-else :value="false"
                @change="changePermission(role = item.role, permission = 'view_system_roles')" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <h4 class="text-black">View System Permissions</h4>
          <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="index">
            <div class="col-4">{{ item.rolename }}</div>
            <div class="col">
              <RockerSwitch v-if="item.system_permissions == 1" :value="true"
                @change="changePermission(role = item.role, permission = 'system_permissions')" />
              <RockerSwitch v-else :value="false"
                @change="changePermission(role = item.role, permission = 'system_permissions')" />
            </div>
          </div>
        </div>
      </div>

      <div>
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-3">Add New System Role</div>
          <div class="col-2">Edit System Role</div>
          <div class="col-3">Delete System Role</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- New Role -->
          <div class="col-3">
            <RockerSwitch v-if="item.new_system_role == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'new_system_role')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'new_system_role')" />
          </div>

          <!-- Edit Role -->
          <div class="col-2">
            <RockerSwitch v-if="item.edit_system_role == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'edit_system_role')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'edit_system_role')" />
          </div>

          <!-- Delete Role -->
          <div class="col-3">
            <RockerSwitch v-if="item.delete_system_role == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'delete_system_role')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'delete_system_role')" />
          </div>

        </div>
      </div>
    </div>
  </b-tab>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import appConfig from "@/app.config";
import { permissionMethods } from "@/state/helpers";

export default {
  name: "RolePermissions",
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  props: {
    permissions: Array,
  },
  components: {
    RockerSwitch
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
    };
  },
  computed: {
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.view_system_roles == 1);
    },
  },

  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>